export default __webpack_public_path__ + "static/zaru_collages_v6-13-ec2a76b1300f71be0a872a25e0653a67.png";